<form
  class="easy-form"
  [formGroup]="registrationForm"
  appScrollToInvalidControl
  autocomplete="on"
>
  <h1 class="my-0">
    {{ TITLE + "REGISTRATION" | translate | uppercase }}
  </h1>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'FIRST_NAME'"
        [placeholder]="PLACEHOLDER + 'FIRST_NAME'"
        formControlName="firstName"
        [autocomplete]="'given-name'"
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'LAST_NAME'"
        [placeholder]="PLACEHOLDER + 'LAST_NAME'"
        formControlName="lastName"
        [autocomplete]="'family-name'"
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'EMAIL'"
        [placeholder]="PLACEHOLDER + 'EMAIL'"
        formControlName="email"
        [autocomplete]="'username'"
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-phone-subform
        [label]="TITLE + 'PHONE'"
        [placeholder]="PLACEHOLDER + 'PHONE'"
        formControlName="phoneNumber"
      >
      </app-easy-phone-subform>
    </mat-form-field>
  </div>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'PASSWORD'"
        [placeholder]="PLACEHOLDER + 'PASSWORD'"
        [type]="passwordVisibility ? 'password' : 'text'"
        formControlName="password"
        [iconSuffixClickable]="true"
        [iconSuffix]="passwordVisibility ? 'visibility_off' : 'visibility'"
        (clickedSuffixEvent)="passwordVisibility = !passwordVisibility"
        [autocomplete]="'new-password'"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <div class="in-two-columns">
    <div>
      <mat-form-field class="w-100">
        <app-easy-input
          [label]="TITLE + 'CONFIRM_PASSWORD'"
          [placeholder]="PLACEHOLDER + 'CONFIRM_PASSWORD'"
          [type]="confirmPasswordVisibility ? 'password' : 'text'"
          formControlName="confirmPassword"
          [iconSuffixClickable]="true"
          [iconSuffix]="
            confirmPasswordVisibility ? 'visibility_off' : 'visibility'
          "
          (clickedSuffixEvent)="
            confirmPasswordVisibility = !confirmPasswordVisibility
          "
          [autocomplete]="'new-password'"
        >
        </app-easy-input>
      </mat-form-field>

      <mat-error
        class="mat-error"
        *ngIf="
          registrationForm.hasError('notMatched') &&
          !registrationForm.get('confirmPasswordControl')?.hasError('required')
        "
      >
        {{ "REGISTRATION.HINT.PASSWORD_NO_MATCH" | translate }}
      </mat-error>
    </div>
  </div>

  <button
    mat-raised-button
    color="primary"
    class="submit-button"
    (click)="onSubmit()"
  >
    {{ "REGISTRATION.BTN.REGISTER" | translate | uppercase }}
  </button>
</form>
